import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from '@angular/core';
import {ROUTES} from './vertical-menu-routes.config';
import {HROUTES} from '../horizontal-menu/navigation-routes.config';

import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {customAnimations} from '../animations/custom-animations';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ConfigService} from '../services/config.service';
import {Subscription} from 'rxjs';
import {LayoutService} from '../services/layout.service';
import {PermissionManagerService} from '../services/permission-manager.service';
import {RouteInfo} from './vertical-menu.metadata';
import {Constants} from '../constants/constants';
import {AuthenticationService} from '../services/authentication.service';
import * as swalFunctions from '../data/sweet-alert';

@Component({
  selector: 'app-sidebar',
  templateUrl: './vertical-menu.component.html',
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = 'assets/img/logos/LogoAROVIC.jpg';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  mostrarMenu = false;
  swal = swalFunctions;


  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private permissionManagerService: PermissionManagerService,
    private auth: AuthenticationService) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();

  }


  ngOnInit() {
    setTimeout(() => this.loadMenu(), 300);
  }

  loadMenu() {
    //this.menuItems = ROUTES;
    if (sessionStorage.getItem('userData') !== null && sessionStorage.getItem('userData') !== undefined) {
      const menuItems: RouteInfo[] = [];
      for (const menu of ROUTES) {
        if (menu.idcontro !== 0 && this.permissionManagerService.isGranted(menu.idcontro)) {
          const submen: RouteInfo[] = []
          for (const submenu of menu.submenu) {
            if (submenu.idcontro !== 0 && this.permissionManagerService.isGranted(submenu.idcontro)) {
              submen.push(submenu);
            }
          }
          if (menu.submenu.length === 0 || submen.length > 0) {
            menu.submenu = submen;
            menuItems.push(menu)
          }
        } else if (menu.idcontro === 0) {
          if (this.permissionManagerService.authenticationService.isUsuarioEspecial()) {
            menuItems.push(menu);
          }
        }
      }
      this.menuItems = menuItems;

      if (this.auth.cambioContrasena() < 13) {
        this.mostrarMenu = true;
      } else {
        this.swal.TypeInfo('Cambio de Contraseña', 'Ya es tiempo de que modifiques tu contraseña')
        this.router.navigate(['administracion/perfil-usuario']);
      }

    } else {
      setTimeout(() => {
        this.loadMenu()
      }, 1000)
    }

    this.cdr.detectChanges();
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === 'Side') {
          this.collapseSidebar = collapse;
        }
      });


  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {


    if (this.config.layout.menuPosition === 'Top') { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    } else if (this.config.layout.menuPosition === 'Side') { // Vertical Menu{
      //this.menuItems = ROUTES
    }


    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }

    this.collapseSidebar = !!this.config.layout.sidebar.collapsed;
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({layout: conf.layout});

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('resize', true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    } else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
